module.exports = __webpack_public_path__ + "img/B01_HQ09.8a8b18fc.jpg";